import React, { useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';

const BarChart = ({ 
  totalSales = [],
  currentPeriodLabel = 'Ventas Mensuales'
}) => {
  const [options, setOptions] = useState({});

  useEffect(() => {
    // Verifica que tenemos datos para procesar
    if (!totalSales || totalSales.length === 0) {
      return;
    }

    // Extrae meses y valores de ventas
    const months = totalSales.map(item => {
      // Formatear el mes para mostrarlo como "MMM YYYY"
      const date = new Date(item.month + '-01');
      return date.toLocaleDateString('es-ES', { month: 'short', year: 'numeric' });
    });
    
    const salesValues = totalSales.map(item => parseFloat(item.totalSales));

    // Calcula los porcentajes de cambio entre meses consecutivos
    const changePercentages = salesValues.map((value, index) => {
      if (index === 0) return null;
      const prevValue = salesValues[index - 1];
      return prevValue > 0 
        ? (((value - prevValue) / prevValue) * 100).toFixed(2)
        : 100; // Si no hay ventas previas, asumir 100% de crecimiento
    });

    setOptions({
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        },
        formatter: function(params) {
          const value = params[0].value;
          return `${params[0].seriesName} (${params[0].name}): ${new Intl.NumberFormat('es-ES', { 
            style: 'currency', 
            currency: 'EUR'
          }).format(value)}`;
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '8%',
        top: '10%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: months,
        axisLabel: {
          rotate: 30
        }
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: function(value) {
            return new Intl.NumberFormat('es-ES', { 
              style: 'currency', 
              currency: 'EUR',
              maximumFractionDigits: 0
            }).format(value);
          }
        }
      },
      series: [
        {
          name: currentPeriodLabel,
          type: 'bar',
          data: salesValues,
          itemStyle: {
            color: function(params) {
              // Color basado en si el valor es mayor que el mes anterior
              if (params.dataIndex === 0) return '#5470c6'; // Primer mes siempre azul
              
              const isGrowth = salesValues[params.dataIndex] >= salesValues[params.dataIndex - 1];
              return isGrowth ? '#3ba272' : '#c23531';  // Verde si hay crecimiento, rojo si hay disminución
            },
            borderRadius: [4, 4, 0, 0]
          },
          label: {
            show: false
          },
          barWidth: '50%'
        }
      ]
    });
  }, [totalSales, currentPeriodLabel]);

  return <ReactECharts option={options} style={{ height: '100%' }} />;
};

export default BarChart;